var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDollar18 = function SvgAIconDollar18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4003 5H8.14655C7.11805 5.0006 6.23441 5.60852 6.03924 6.44978C5.84407 7.29105 6.39215 8.1295 7.34631 8.44933L10.6497 9.54933C11.6061 9.86806 12.1562 10.7075 11.9608 11.5501C11.7654 12.3926 10.8795 13.001 9.84946 13H6.59889",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99902 15V13",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99902 5V3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconDollar18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xMS40MDAzIDVIOC4xNDY1NUM3LjExODA1IDUuMDAwNiA2LjIzNDQxIDUuNjA4NTIgNi4wMzkyNCA2LjQ0OTc4QzUuODQ0MDcgNy4yOTEwNSA2LjM5MjE1IDguMTI5NSA3LjM0NjMxIDguNDQ5MzNMMTAuNjQ5NyA5LjU0OTMzQzExLjYwNjEgOS44NjgwNiAxMi4xNTYyIDEwLjcwNzUgMTEuOTYwOCAxMS41NTAxQzExLjc2NTQgMTIuMzkyNiAxMC44Nzk1IDEzLjAwMSA5Ljg0OTQ2IDEzSDYuNTk4ODkiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik04Ljk5OTAyIDE1VjEzIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNOC45OTkwMiA1VjMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";